import { ListItemText } from "@mui/material";
import { differenceInMinutes } from "date-fns";
import { MedkitIcon } from "@/components/common/icons";
import { getUniqServicesProviders } from "@/utils/appointment";
import { formattedTime } from "@/utils/date";
import { useMultiProviderAppointmentDrawerContext } from "../multiProviderAppointmentDrawerContext";
import { SuccessScreenSectionStack } from "./successScreenSectionStack";

export const SuccessScreenAppointmentServices = () => {
  const { appointmentServices } = useMultiProviderAppointmentDrawerContext();

  const servicesProviders = getUniqServicesProviders(appointmentServices);
  const isSingleProvider = servicesProviders.length === 1;

  return (
    <SuccessScreenSectionStack
      label="Service(s)"
      options={appointmentServices.map((service, index) => {
        const duration = differenceInMinutes(
          service.endTime,
          service.startTime
        );

        return {
          icon: <MedkitIcon size={24} />,
          content: (
            <ListItemText
              sx={{ m: 0 }}
              primary={service.serviceMenuItem.name}
              secondary={
                isSingleProvider
                  ? `${formattedTime(duration)}`
                  : `${service.provider.user.firstName} ${service.provider.user.lastName} • ${formattedTime(duration)}`
              }
            />
          ),
          isLast: index === appointmentServices.length - 1,
        };
      })}
    />
  );
};
